export default __webpack_public_path__ + "static/media/ic-notification-filled.36d45b4e.svg";